import React, { useEffect } from 'react';

import { Outlet, useLocation } from "react-router-dom";

import AddReclamationButton from './AddReclamationButton';
import NavBar from './NavBar/';

import AffectationDialog from '../Screens/AffectationDialog';
import AddReclamationDialog from '../Screens/AddReclamationDialog';
import AddMemoDialog from '../Screens/AddMemoDialog';
import AddQuestionDialog from '../Screens/AddQuestionDialog';
import AddActionDialog from '../Screens/AddActionDialog';
import ObservateursDialog from '../Screens/ObservateursDialog';
import ClotureDialog from '../Screens/ClotureDialog';
import SetDateVerificationDialog from '../Screens/SetDateVerificationDialog';
import AnnulerClotureDialog from '../Screens/AnnulerClotureDialog';
import ImportSouffranceDialog from '../Screens/ImportSouffranceDialog';

import NotificationSnackbar from './NotificationSnackbar';



const Layout = () => {
    const location = useLocation();
    const isLoginPage = location.pathname === '/login';

    useEffect(() => {
        // Désactiver le scroll sur la page de login
        if (isLoginPage) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup au démontage
        return () => {
            document.body.style.overflow = '';
        };
    }, [isLoginPage]);

    return (
        <>
            <div style={{
                position: 'fixed',
                top: isLoginPage ? '72px' : 0,
                left: isLoginPage ? '50%' : 0,
                right: isLoginPage ? 'auto' : 0,
                transform: isLoginPage ? 'translateX(-50%)' : 'none',
                maxWidth: isLoginPage ? '450px' : 'none',
                width: isLoginPage ? '90%' : '100%',
                zIndex: 1100,
            }}>
                <NavBar isLoginPage={isLoginPage} />
            </div>

            <div style={{ paddingTop: isLoginPage ? '136px' : '72px', display: 'flex', flexDirection: 'column' }}>
                <Outlet />
            </div>

            <AddReclamationButton />

            <AffectationDialog />

            <AddReclamationDialog />

            <AddMemoDialog />

            <AddQuestionDialog />

            <AddActionDialog />

            <ObservateursDialog />

            <ClotureDialog />

            <SetDateVerificationDialog />

            <AnnulerClotureDialog />

            <ImportSouffranceDialog />

            <NotificationSnackbar />

        </>
    )
};

export default Layout;
